import Spinner from "@base/ui/Button/Spinner";
import { useTranslation } from "react-i18next";

/**
 * Suspense fallback UI for loading state.
 * Use with <Suspense fallback={<LoadingFallback />}>.
 */
export function LoadingFallback() {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-4 justify-center items-center min-h-[200px] p-6" aria-busy="true" aria-live="polite">
      <Spinner size={32} />
      <p className="text-body2 text-gray-700">{t("loading")}</p>
    </div>
  );
}
